// src/services/leaderboard.js
// Supabase REST API — challenge & infinite leaderboards.

const BASE = 'https://bnwakofsuhnglavdwmin.supabase.co/rest/v1';
const KEY  = 'sb_publishable_mdJ0aJ7gQhe7ju3m5kr_MA_a55EaJlv';

const HEADERS = {
  'apikey':        KEY,
  'Authorization': `Bearer ${KEY}`,
  'Content-Type':  'application/json',
  'Prefer':        'return=minimal',
};

// ── Read ─────────────────────────────────────────────────────────────────────

export async function fetchTopChallenge(limit = 12) {
  const r = await fetch(
    `${BASE}/challenge_scores?order=total_score.desc&limit=${limit}&select=player_name,total_score,country_code,created_at`,
    { headers: HEADERS }
  );
  return r.ok ? r.json() : [];
}

export async function fetchTopInfinite(limit = 12) {
  const r = await fetch(
    `${BASE}/infinite_scores?order=score.desc&limit=${limit}&select=player_name,score,wave,country_code,created_at`,
    { headers: HEADERS }
  );
  return r.ok ? r.json() : [];
}

// ── Player rank (count scores strictly above theirs + 1) ─────────────────────

export async function fetchChallengeRank(playerScore) {
  if (!playerScore) return null;
  const r = await fetch(
    `${BASE}/challenge_scores?total_score=gt.${playerScore}&select=id`,
    { headers: { ...HEADERS, 'Prefer': 'count=exact', 'Range': '0-0' } }
  );
  const range = r.headers.get('Content-Range') || '*/0';
  const above = parseInt(range.split('/')[1]) || 0;
  return above + 1;
}

export async function fetchInfiniteRank(playerScore) {
  if (!playerScore) return null;
  const r = await fetch(
    `${BASE}/infinite_scores?score=gt.${playerScore}&select=id`,
    { headers: { ...HEADERS, 'Prefer': 'count=exact', 'Range': '0-0' } }
  );
  const range = r.headers.get('Content-Range') || '*/0';
  const above = parseInt(range.split('/')[1]) || 0;
  return above + 1;
}

// ── Write ─────────────────────────────────────────────────────────────────────

export async function submitChallenge({ player_name, total_score, country_code }) {
  const r = await fetch(`${BASE}/challenge_scores`, {
    method:  'POST',
    headers: HEADERS,
    body:    JSON.stringify({ player_name, total_score, country_code }),
  });
  return r.ok;
}

export async function submitInfinite({ player_name, score, wave, country_code }) {
  const r = await fetch(`${BASE}/infinite_scores`, {
    method:  'POST',
    headers: HEADERS,
    body:    JSON.stringify({ player_name, score, wave, country_code }),
  });
  return r.ok;
}
